import { wrapFetch } from '../libs/fetch';
import type { FavoriteRecruitment } from '../types/favoriteRecruitments';
import type { FavoriteRecruitmentsResponse } from '../types/favoriteRecruitments';

export const getFavoriteRecruitment = async (recruitmentId: string | number) => {
  return await wrapFetch<FavoriteRecruitment>(`/api/v1/favorite_recruitments/${recruitmentId}`);
};

export const createBookmarkForFavoriteRecruitment = async (recruitmentId: string | number) => {
  return await wrapFetch(`/api/v1/favorite_recruitments/create_bookmark_for_favorite_recruitment/${recruitmentId}`);
};

export const deleteBookmarkForFavoriteRecruitment = async ({
  recruitmentId,
  csrfToken,
}: {
  recruitmentId: string | number;
  csrfToken: string;
}) => {
  return await wrapFetch(`/api/v1/favorite_recruitments/delete_bookmark_for_favorite_recruitment/${recruitmentId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};

export const fetchFavoriteRecruitmentsList = async () => {
  return await wrapFetch<FavoriteRecruitmentsResponse>('/api/v1/favorite_recruitments');
};
